<template>
  <div class="app-container">
    <div class="filter-container">
      <div
        v-for="item in routes_type"
        :key="item.key"
        :class="['item', {active: activeType === item.key}]"
        @click="handleChangeType(item)"
      >{{ item.name }}</div>
    </div>
    <component :is="activeType" />
  </div>
</template>

<script>
import channelList from "./channelList";
import levelTemplate from "./levelTemplate";
import bonusTemplate from "./bonusTemplate";
import warningTemplate from "./warnigTemplate";

const ROUTES_TYPE = [
  { key: "channelList", name: "Channel List" },
  { key: "levelTemplate", name: "Channel Template" },
  { key: "warningTemplate", name: "Warning Template" },
  { key: "bonusTemplate", name: "Bonus Template" },
];

export default {
  components: {
    channelList,
    levelTemplate,
    warningTemplate,
    bonusTemplate
  },
  data() {
    return {
      activeType: "",
      routes_type: ROUTES_TYPE
    };
  },
  created() {
    this.handleChangeType(this.routes_type[0]);
  },
  methods: {
    handleChangeType(item) {
      this.activeType = item.key;
    }
  }
};
</script>

<style lang="scss" scoped>
.app-container {
  .filter-container {
    padding: 20px 18px 0 16px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .item {
      padding: 6px 14px;
      border: 1px solid #f5f5f5;
      cursor: pointer;
      font-size: 14px;
      &:nth-child(1) {
        border-radius: 4px 0 0 4px;
      }
      &:nth-child(2) {
        border-left: 0;
        border-right: 0;
      }
      &:nth-child(3) {
        border-left: 0;
        border-right: 0;
      }
      &:nth-child(4) {
        border-radius: 0 4px 4px 0;
      }
    }
    .active {
      background-color: #00a791;
      border: 1px solid #00a791;
      color: #fff;
    }
  }
}
</style>
